import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'

const A4_WIDTH_MM = 210
const A4_HEIGHT_MM = 297
const CAPTURE_WIDTH_PX = 794
const CAPTURE_HEIGHT_PX = 1123

const preparePageForCapture = (page: HTMLElement) => {
  page.style.transform = 'none'
  page.style.width = `${CAPTURE_WIDTH_PX}px`
  page.style.height = 'auto'
  page.style.minHeight = `${CAPTURE_HEIGHT_PX}px`
  page.style.maxHeight = 'none'
  page.style.overflow = 'visible'
  page.style.display = 'flex'
  page.style.flexDirection = 'column'
  page.style.boxShadow = 'none'
  page.style.margin = '0'
  page.style.boxSizing = 'border-box'
}

const measurePageHeight = (page: HTMLElement) => {
  preparePageForCapture(page)
  return Math.max(CAPTURE_HEIGHT_PX, Math.ceil(page.scrollHeight))
}

export const generateScorecardPdf = async (scorecardEl: HTMLElement, filename: string) => {
  const pages = Array.from(scorecardEl.querySelectorAll('.scorecard-page')) as HTMLElement[]
  if (pages.length === 0) {
    throw new Error('No scorecard pages found')
  }

  const pdf = new jsPDF({
    unit: 'mm',
    format: 'a4',
    orientation: 'portrait',
  })

  for (let index = 0; index < pages.length; index++) {
    const page = pages[index]
    const captureHeight = measurePageHeight(page)
    page.style.height = `${captureHeight}px`
    page.style.minHeight = `${captureHeight}px`

    const canvas = await html2canvas(page, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
      width: CAPTURE_WIDTH_PX,
      height: captureHeight,
      windowWidth: CAPTURE_WIDTH_PX,
      windowHeight: captureHeight,
      scrollX: 0,
      scrollY: -window.scrollY,
    })

    const imgData = canvas.toDataURL('image/jpeg', 0.98)
    const scale = Math.min(A4_WIDTH_MM / canvas.width, A4_HEIGHT_MM / canvas.height)
    const drawWidth = canvas.width * scale
    const drawHeight = canvas.height * scale
    const xOffset = (A4_WIDTH_MM - drawWidth) / 2
    const yOffset = A4_HEIGHT_MM - drawHeight

    if (index > 0) {
      pdf.addPage()
    }
    pdf.addImage(imgData, 'JPEG', xOffset, yOffset, drawWidth, drawHeight)
  }

  pdf.save(filename)
}
